<script lang="ts">
  import { Button } from '$ui/button'
  import { ChevronRight, Menu, X } from 'lucide-svelte'

  let isMenuOpen: boolean = false

  const closeMenu = () => {
    isMenuOpen = false
  }

  // Click outside action
  function clickOutside(node: HTMLElement) {
    const handleClick = (event: MouseEvent) => {
      if (!node.contains(event.target as Node)) {
        closeMenu()
      }
    }

    document.addEventListener('click', handleClick, true)

    return {
      destroy() {
        document.removeEventListener('click', handleClick, true)
      },
    }
  }
</script>

<header
  class="fixed md:absolute inset-x-0 top-0 z-50 mx-auto max-w-7xl backdrop-blur-sm bg-[#101827]/80 md:bg-transparent"
>
  <nav class="flex items-center justify-between p-6 md:px-8" aria-label="Global">
    <div class="flex md:flex-1">
      <a href="/" class="-m-1.5 p-1.5">
        <span class="sr-only">LastMinute</span>
        <img class="h-8 w-auto" src="/logo-text-white.svg" alt="" />
      </a>
    </div>
    <div class="flex md:hidden">
      <button
        type="button"
        on:click={() => (isMenuOpen = !isMenuOpen)}
        class="-m-2.5 inline-flex items-center justify-center rounded-md p-2.5 text-gray-300"
      >
        <span class="sr-only">Open main menu</span>
        <Menu class="h-6 w-6" />
      </button>
    </div>
    <div class="hidden md:flex md:gap-x-12">
      <a href="/about" class="text-md font-light leading-6 text-gray-300">About</a>
      <a href="/features" class="text-md font-light leading-6 text-gray-300">Features</a>
      <a href="/pricing" class="text-md font-light leading-6 text-gray-300">Pricing</a>
      <a href="/contact" class="text-md font-light leading-6 text-gray-300">Contact</a>
    </div>
    <div class="hidden md:flex md:flex-1 md:justify-end">
      <Button
        size="sm"
        href="https://app.trylastminute.com"
        variant="secondary"
        class="rounded-full p-5 bg-violet-500 hover:bg-violet-400 text-white"
      >
        Get Started <ChevronRight class="h-4 w-4 ml-1" />
      </Button>
    </div>
  </nav>
  {#if isMenuOpen}
    <div class="fixed inset-0 z-[100] bg-[#101827]/95 md:hidden">
      <nav
        class="fixed inset-y-0 left-0 z-[101] w-full h-full flex flex-col bg-[#101827] px-6 py-6"
        use:clickOutside
      >
        <div class="flex items-center justify-between">
          <a href="/" on:click={closeMenu} class="-m-1.5 p-1.5">
            <span class="sr-only">LastMinute</span>
            <img class="h-8 w-auto" src="/logo-text-white.svg" alt="" />
          </a>
          <button
            type="button"
            class="-m-2.5 rounded-md p-2.5 text-gray-300"
            on:click={() => (isMenuOpen = false)}
          >
            <X class="h-6 w-6" />
          </button>
        </div>
        <div class="flex-1 mt-6 p-6 bg-[#101827]">
          <div class="flex flex-col space-y-4 text-right">
            <a href="/about" on:click={closeMenu} class="text-base font-light text-gray-300"
              >About</a
            >
            <a href="/features" on:click={closeMenu} class="text-base font-light text-gray-300"
              >Features</a
            >
            <a href="/pricing" on:click={closeMenu} class="text-base font-light text-gray-300"
              >Pricing</a
            >
            <a href="/contact" on:click={closeMenu} class="text-base font-light text-gray-300"
              >Contact</a
            >
          </div>
          <div class="mt-auto pt-6">
            <Button
              size="sm"
              href="https://app.trylastminute.com"
              variant="secondary"
              class="w-full rounded-full p-5 bg-violet-500 hover:bg-violet-400 text-white"
              on:click={closeMenu}
            >
              Get Started <ChevronRight class="h-4 w-4 ml-1" />
            </Button>
          </div>
        </div>
      </nav>
    </div>
  {/if}
</header>
